export default function listSortHandler (value,bool,setBool,data,setData,isDate) {
    if(isDate){
        setData(data.sort((a,b) => bool ? new Date(a[value]) - new Date(b[value]) : new Date(b[value]) - new Date(a[value])));
    }
    else{
        setData(data.sort((a, b) => bool ? a[value].localeCompare(b[value]) : b[value].localeCompare(a[value])));
    }
    setBool(bool);
}